<template>
  <div class="page">
    <div class="login-wrapper">
      <div class="login-content">
        <div class="site-logo">
          <img src="../../assets/images/logo-trans.png" />
        </div>
        <div class="site-text">
          <div class="main">精进卓越&nbsp;&nbsp;赋能增长</div>
          <div class="sub">欢迎使用百威中国售点物料一站式服务平台</div>
        </div>
        <div class="sso-info"
          v-loading="loading"
          element-loading-text="正在跳转统一登录服务..."
          element-loading-background="rgba(0, 0, 0, 0.1)"
          element-loading-spinner="el-icon-loading"
          element-loading-custom-class="loadingText">
        </div>
      </div>
    </div>
    <Footer :show-help="false"/>
  </div>
</template>

<script>
import Footer from '../layout/components/footer'
import authApi from '@/api/auth'
export default {
  name: 'sso-sign-in',
  components: {
    Footer
  },
  data () {
    return {
      loading: true,
      target: '/home'
    }
  },
  created () {
    this.doSignIn()
  },
  methods: {
    doSignIn () {
      console.log('do sso sign in')
      // TODO 如果当前localstorage里可以拿到用户已过期的缓存对象，则可以取出loginAccount作为默认值传入接口
      // 如果需要在登录后跳转到指定地址，在这里设置target信息，target设为route name还是path，需要再讨论
      const params = {
        loginAccount: '',
        target: this.target
      }
      authApi.ssoSignIn(params).then(response => {
        if (response.data.resultCode === '0') {
          const needAuth = response.data.resultData.needAuth || ''
          if (needAuth === '1') {
            const redirectUrl = response.data.resultData.redirectUrl
            window.location.href = redirectUrl
          } else {
            this.$store.commit('SET_USER_INFO', response.data.resultData)
            this.$router.push(this.target)
          }
        } else {
          this.$alert('请求统一登录服务失败')
        }
      }).catch(() => {
        this.$alert('服务异常')
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.page {
  height: 100%;
}
.login-wrapper {
  height: calc(100% - 100px);
  width: 100%;
  color: $base-white;
  box-sizing: border-box;
  background: url("../../assets/images/login-bg.jpg") center no-repeat;
  background-size: cover;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  .site-logo {
    width: 166px;
    height: 84px;
    margin: 0 auto;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .site-text {
    margin: 60px 0 100px 0;
    .main {
      font-weight: 700;
      font-size: 50px;
      margin-bottom: 15px;
    }
    .sub {
      font-size: 18px;
    }
  }
  .sso-info {
    margin: 30px auto;
    padding: 10px;
    width: 400px;
    height: 80px;
    color: #111;
    background-color: #fff;
    border: 1px solid #ccc;
    border-radius: 5px;

    ::v-deep .el-icon-loading {
      color: $base-red;
    }
    ::v-deep .el-loading-text {
      color: $base-red;
    }
  }

}
</style>
